import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const ContainerAutocomplete = styled.div`
  & > div > div {
    margin: 10px 0px;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 20px;
`

export const Title = styled.span`
  color: ${colors.green};
  font-weight: 700;
  font-size: 16px;
`

export const ErrorMessage = styled.div`
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: normal;
  color: ${colors.red};
  padding-right: 5px;
`

export const ContainerHelperMessage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
